import { getPropertyState } from './../containers/properties/properties.selectors';
import { Store, select } from '@ngrx/store';
import { NgxPermissionsService } from 'ngx-permissions';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../containers/auth/auth.service';


@Injectable()
export class PermissionsGuard implements CanActivate {


  constructor(
    public auth: AuthService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public store: Store<any>,
    public permissionsService: NgxPermissionsService,
  ) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const permissions = this.permissionsService.getPermissions();
      let path: Array<any> = [];

      if (route.params.type && !isNaN(route.params.type)) {
        const tabsPermissions = ['PROPERTY_TAB_DETAILS', 'PROPERTY_TAB_CONTACTS', 'PROPERTY_TAB_GALLERY', 'PROPERTY_TAB_MEASURE', 'PROPERTY_TAB_FEATURES', 'PROPERTY_TAB_DOCUMENTS', 'PROPERTY_TAB_PAYMENTS'];

        for (let index = 0; index < tabsPermissions.length; index++) {
          if (permissions[tabsPermissions[index]]) {
            const redirectTab = tabsPermissions[index].split('PROPERTY_TAB_')[1].toLocaleLowerCase()
            path = [route.params.type, redirectTab]
            break;
          }
        }

      } else if (route.params.type && isNaN(route.params.type)) {

        const tabsPermissions = ['STATUS_DATA_ENTRY', 'STATUS_ASSESSMENT', 'STATUS_BILLING', 'STATUS_OBJECTION']
        const acceptedPermission = route.data.permissions.only(route, state);

        // if (permissions[acceptedPermission]) {
        //   resolve(true)
        //   return true;
        // }

        if (!permissions[acceptedPermission]) {
          for (let index = 0; index < tabsPermissions.length; index++) {
            if (permissions[tabsPermissions[index]]) {
              const redirectTab = tabsPermissions[index].split('STATUS_')[1].toLocaleLowerCase()
              path = [redirectTab]
              break;
            }
          }
        }
      }

      if (path.length) {
        this.router.navigate(['properties', ...path])
      }

      resolve(true)
    });
  }
}